/** 声明：该组件代码copy了fusion/next的box组件后做修改 */
import React, { Component } from 'react';
import cx from 'classnames';
import { createStyle, filterHelperStyle, filterInnerStyle, filterOuterStyle, getChildMargin, getMargin, getSpacingHelperMargin, } from './create-style';
/**
 * 遍历box子元素，对于fragement元素取一层下级子元素，避免使用fragement时无法自动计算边距的问题
 * @param children box的子元素
 * @returns 整理后的元素列表
 */
function getChildrenWithoutFragment(children) {
    let result = [];
    React.Children.toArray(children).forEach((item) => {
        // @ts-ignore type
        if (typeof item === 'object' && item.type === React.Fragment) {
            // @ts-ignore props
            result = result.concat(item.props.children);
        }
        else {
            result.push(item);
        }
    });
    return result;
}
const createChildren = (children, { spacing, direction, wrap }) => {
    let array = getChildrenWithoutFragment(children);
    if (!children) {
        return null;
    }
    return array.map((child, index) => {
        let spacingMargin = {};
        spacingMargin = getChildMargin(spacing);
        if (!wrap) {
            // 不折行
            const isNone = [index === 0, index === array.length - 1];
            const props = direction === 'row'
                ? ['marginLeft', 'marginRight']
                : ['marginTop', 'marginBottom'];
            ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'].forEach((prop) => {
                if (prop in spacingMargin && props.indexOf(prop) === -1) {
                    spacingMargin[prop] = 0;
                }
                props.forEach((key, i) => {
                    if (key in spacingMargin && isNone[i]) {
                        spacingMargin[key] = 0;
                    }
                });
            });
        }
        if (React.isValidElement(child)) {
            const { margin: propsMargin } = child.props;
            const childPropsMargin = getMargin(propsMargin);
            let gridProps = {};
            // @ts-ignore
            if (['function', 'object'].indexOf(typeof child.type) > -1 &&
                child.type._typeMark === 'responsive_grid') {
                gridProps = createStyle({ display: 'grid', ...child.props });
            }
            return React.cloneElement(child, {
                style: {
                    ...spacingMargin,
                    // ...getBoxChildProps(child.props),
                    ...childPropsMargin,
                    ...gridProps,
                    ...(child.props.style || {}),
                },
            });
        }
        return child;
    });
};
const getStyle = (style = {}, props) => {
    return {
        ...createStyle({ display: 'flex', ...props }),
        ...style,
    };
};
const getOuterStyle = (style, styleProps) => {
    const sheet = getStyle(style, styleProps);
    return filterOuterStyle(sheet);
};
const getHelperStyle = (style, styleProps) => {
    const sheet = getStyle(style, styleProps);
    return filterHelperStyle({
        ...sheet,
        ...getSpacingHelperMargin(styleProps.spacing),
    });
};
const getInnerStyle = (style, styleProps) => {
    const sheet = getStyle(style, styleProps);
    return filterInnerStyle(sheet);
};
/**
 * Box
 */
class CnBox extends Component {
    static defaultProps = {
        prefix: 'cn-ui-m-',
        direction: 'column',
        wrap: false,
    };
    render() {
        const { prefix, direction, justify, align, wrap, flex, spacing, padding, margin, style, className, children, ...others } = this.props;
        const styleProps = {
            direction,
            justify,
            align,
            wrap,
            flex,
            spacing,
            padding,
            margin,
        };
        const styleSheet = getStyle(style, styleProps);
        const boxs = createChildren(children, {
            spacing,
            direction,
            wrap,
        });
        const clsPrefix = `${prefix}box`;
        const cls = cx(clsPrefix, className);
        if (wrap && spacing) {
            const outerStyle = getOuterStyle(style, styleProps);
            const helperStyle = getHelperStyle(style, styleProps);
            const innerStyle = getInnerStyle(style, styleProps);
            return (React.createElement("div", { style: outerStyle, className: cls, ...others },
                React.createElement("div", { style: helperStyle },
                    React.createElement("div", { style: innerStyle, className: clsPrefix }, boxs))));
        }
        return (React.createElement("div", { style: styleSheet, className: cls, ...others }, boxs));
    }
}
export { CnBox };
